import { Activity, FileX, AlertTriangle, Send, Wallet } from 'lucide-react';
import type { KpiStats } from '../types/campaign';
import { KpiCard } from './KpiCard';
import { useLanguage } from '../contexts/LanguageContext';
import { formatEuroNoDecimals } from '../utils/currency';

export type KpiType = 'campaigns' | 'invoices_not_issued' | 'invoice_requests' | 'invoices_overdue' | 'payments_ready';

interface DashboardProps {
  kpiStats: KpiStats;
  loading?: boolean;
  onKpiClick?: (kpiType: KpiType) => void;
}

// One path for client invoices: por pedir (Accounts) → pedidos (who issues)
// → vencidas; then what is ready to pay out
export function Dashboard({ kpiStats, loading, onKpiClick }: DashboardProps) {
  const { t } = useLanguage();

  return (
    <div className="mb-6">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 stagger-children">
        <KpiCard
          label={t('kpi.runningCampaigns')}
          count={kpiStats.campaigns_running ?? 0}
          sublabel={t('kpi.inConsultation').replace('{0}', String(kpiStats.campaigns_consultation))}
          icon={Activity}
          colorClass="border-blue-200"
          loading={loading}
          onClick={() => onKpiClick?.('campaigns')}
        />
        <KpiCard
          label={t('kpi.invoicesNotIssued')}
          count={kpiStats.invoices_not_issued}
          icon={FileX}
          colorClass="border-orange-200"
          loading={loading}
          onClick={() => onKpiClick?.('invoices_not_issued')}
        />
        <KpiCard
          label={t('kpi.invoiceRequests')}
          count={kpiStats.invoice_requests_pending ?? 0}
          sublabel={formatEuroNoDecimals(kpiStats.invoice_requests_amount ?? 0)}
          icon={Send}
          colorClass="border-amber-200"
          loading={loading}
          onClick={() => onKpiClick?.('invoice_requests')}
        />
        <KpiCard
          label={t('kpi.invoicesOverdue')}
          count={kpiStats.invoices_overdue}
          icon={AlertTriangle}
          colorClass="border-red-200"
          loading={loading}
          onClick={() => onKpiClick?.('invoices_overdue')}
        />
        <KpiCard
          label={t('kpi.paymentsReady')}
          count={kpiStats.payments_ready}
          sublabel={formatEuroNoDecimals(kpiStats.payments_ready_amount ?? 0)}
          icon={Wallet}
          colorClass="border-emerald-200 hero-emerald"
          loading={loading}
          onClick={() => onKpiClick?.('payments_ready')}
        />
      </div>
    </div>
  );
}
